"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CarouselBulletList = void 0;
var react_1 = __importDefault(require("react"));
var ramda_1 = require("ramda");
var List_1 = require("../List");
var CarouselContext_1 = require("./CarouselContext");
var CarouselBulletList = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    var _b = CarouselContext_1.useCarouselContext(), index = _b.index, nbVisibleItems = _b.nbVisibleItems, loopeable = _b.loopeable, length = _b.length, goTo = _b.goTo;
    var nbBullets = loopeable ? length : length - nbVisibleItems + 1;
    if (nbBullets <= 0) {
        return null;
    }
    return (react_1["default"].createElement(List_1.List, __assign({ className: ['carousel_bullet-list', className], role: "tablist" }, rest), ramda_1.times(function (idx) { return (react_1["default"].createElement(List_1.List.Item, { key: idx, className: ['carousel_bullet', index === idx && 'active'], disabled: index === idx, tabIndex: 0, onClick: function () { return goTo(idx); }, onKeyDown: function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                goTo(idx);
            }
        } })); }, nbBullets)));
};
exports.CarouselBulletList = CarouselBulletList;
//# sourceMappingURL=CarouselBulletList.js.map